module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/6_c3ff66f4c711a47e0a1e6cde5d363b75.png";